export default class FloatNumberValidator {
    static getInstance() {
        return getInstance()
    }

    constructor(decimalSeparator) {
        this.decimalSeparator = decimalSeparator || '.';
        this.validationRegexp = new RegExp('^\\d*[' + this.decimalSeparator + ',.]?\\d*$');
    }

    getDecimalSeparator() {
        return this.decimalSeparator;
    };

    isValidNumber(string) {
        return String(string).match(this.validationRegexp) !== null;
    };

    parseFloat(string) {
        string = String(string);
        string = string.replace(this.decimalSeparator, '.');
        string = string.replace(',', '.');

        if (string === '.') return 0;

        return parseFloat(string);
    };
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new FloatNumberValidator(window.SystemSettings.decimalSeparator)
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ratesEditor/FloatNumberValidator.js